import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Cta from "@/components/Cta";

const NotFound = () => {
  return (
    <div className="flex h-screen w-full flex-col justify-between">
      <Header />
      <main className="flex h-full items-center justify-center">
        <Cta />
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
